var isNotNull = function isNotNull(value) {
  return value !== null;
};

function getFinalKeyframe(keyframes, _ref, finalKeyframe) {
  var repeat = _ref.repeat,
      _ref$repeatType = _ref.repeatType,
      repeatType = _ref$repeatType === void 0 ? "loop" : _ref$repeatType;
  var speed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var resolvedKeyframes = keyframes.filter(isNotNull);
  var useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
  var index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
  return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

export { getFinalKeyframe };